import api from "../../api/index.js";

const state = {
  memberAddress: null,
  isChangeUser:false
};

const getters = {};

const actions = {
  WebHome({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/Home/WebHome",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }
};

const mutations = {
  setMemberAddress(state, payload) {
    //console.log(payload);
    state.memberAddress = payload.data;
  },
  setIsChangeUser(state,payload){
    state.isChangeUser = payload.data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/home.js